module.exports = __webpack_public_path__ + "img/banner-4.9cb0b6d7.jpg";